export type PriceFetchTarget = 'ana' | 'skyticket' | 'travelko';

export const ANA_SOURCE_PREFIX = 'ana_official';
export const SCRAPED_SOURCE_PREFIXES: PriceFetchTarget[] = ['skyticket', 'travelko'];

// バックエンドの SearchRouteResolverService と同じ前方一致で取得元を判定する
export const resolvePriceFetchTarget = (sources: string[]): PriceFetchTarget | null => {
  if (sources.some(s => s.startsWith(ANA_SOURCE_PREFIX))) return 'ana';
  return SCRAPED_SOURCE_PREFIXES.find(prefix => sources.some(s => s.startsWith(prefix))) ?? null;
};

export type ScrapedFetchTarget = Exclude<PriceFetchTarget, 'ana'>;

export const isScrapedFetchTarget = (target: PriceFetchTarget | null): target is ScrapedFetchTarget =>
  target != null && target !== 'ana';
